import { BsCameraVideoOffFill, BsMicMuteFill } from 'react-icons/bs';
import { GoAlertFill } from 'react-icons/go';
import { ImUserPlus } from 'react-icons/im';
import { MdOutlineWifiOff } from 'react-icons/md';
import { FaDotCircle } from 'react-icons/fa';
import { MdStopCircle } from 'react-icons/md';

import CapacityLimitImg from '@src/assets/images/CapacityLimit.png';

export const INFO_MODAL_ICONS = {
  ACCESS_MIC: <BsMicMuteFill className="icon" color="#EF4444" />,
  ACCESS_CAMERA: <BsCameraVideoOffFill className="icon" color="#EF4444" />,
  CONNECTION_ISSUE: <MdOutlineWifiOff className="icon" color="#EF4444" />,
  WARNING: <GoAlertFill className="icon" color="#FFA000" />,
  CONFIRM_ACTION: <ImUserPlus className="icon" color="#22B57E" />,
  CAPACITY_LIMIT: CapacityLimitImg,
  START_RECORDING: <FaDotCircle className="icon" color="#22B57E" />,
  STOP_RECORDING: <MdStopCircle className="icon" color="#EF4444" />,
};
